import { item } from './item/index.hook';
import { mock } from './mock.hook';
import { packHouse } from './pack-house/index.hook';
import { registration } from './registration/index.hook';
import { util } from './utils/utils.hook';

export const apiHooks = {
    mock,
    packHouse,
    registration,
    item,
    util,
};
